// USAMOS JQUERY PARA SLICK
(function($) {

  const buildVariantUrl = (baseUrl, variantId) => {
    if (!baseUrl || !variantId) return '#';
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    return url.toString();
  };

  function initializeCard(contextStr, cardDOM) {
    const card = $(cardDOM);

    if (card.hasClass('js-custom-card-init')) {
      return;
    }

    card.addClass('js-custom-card-init');

    const carouselElement = card.find('.slick-slider-wrapper');
    let productCarousel = null;

    const checkIsMobile = () => window.innerWidth <= 767;
    let isMobileState = checkIsMobile();

    const allSlides = card.find('.slide-item');
    const totalSlides = allSlides.length;
    const progressBarIndicator = card.find('.product-card__progress-indicator');
    const variantSelectors = card.find('.product-variant-selector');
    const imageLinks = card.find('.product-image-link');
    const titleLink = card.find('.card__heading a.full-unstyled-link');
    const priceLink = card.find('.card__heading.h5 a.full-unstyled-link');

    let silverMediaId = null;
    let goldMediaId = null;

    const initCarousel = () => {
      const isMobileActual = checkIsMobile();

      if (productCarousel && carouselElement.hasClass('slick-initialized')) {
        carouselElement.slick('unslick');
        productCarousel = null;
      }

      if (silverMediaId === null || goldMediaId === null) {
        silverMediaId = variantSelectors.filter('.silver-variant').data('variant-media-id');
        goldMediaId = variantSelectors.filter('.gold-variant').data('variant-media-id');
      }

      if (isMobileActual) {
        carouselElement.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          draggable: true,
          swipe: true,
          adaptiveHeight: true,
        });

        productCarousel = carouselElement;

        productCarousel.on('init', function(event, slick) {
          const initialVariantSelector = card.find('.product-variant-selector.selected');

          if (initialVariantSelector.length) {
            const initialVariantId = initialVariantSelector.data('variant-media-id');
            let initialIndex = -1;

            allSlides.each((index, slide) => {
              if ($(slide).data('media-id') == initialVariantId) {
                initialIndex = index;
                return false;
              }
            });

            if (initialIndex !== -1) {
              slick.currentSlide = initialIndex;
              productCarousel.slick('slickGoTo', initialIndex, false);
            }
          }

          updateUI(slick, totalSlides, progressBarIndicator, variantSelectors, imageLinks, titleLink, priceLink, card, silverMediaId, goldMediaId, true);
        });

        productCarousel.on('afterChange', function(event, slick, currentSlide) {
          updateUI(slick, totalSlides, progressBarIndicator, variantSelectors, imageLinks, titleLink, priceLink, card, silverMediaId, goldMediaId);
        });
      } else {
        allSlides.removeClass('slick-slide slick-active slick-current slick-cloned is-visible is-hover');
        updateUI(null, totalSlides, progressBarIndicator, variantSelectors, imageLinks, titleLink, priceLink, card, silverMediaId, goldMediaId, true);
      }
    };

    function updateUI(slickInstance, total, progressBar, selectors, imageLinks, title, price, cardScope, sId, gId, forceInitial = false) {
      const isMobileActual = checkIsMobile();
      let activeIndex = 0;
      let totalRealSlides = total;
      let currentSelectedSelector = cardScope.find('.product-variant-selector.selected');
      let targetSelector = currentSelectedSelector;
      let selectedVariantUrl = null;
      let selectedVariantId = null;
      let finalUrl = null;

      if (isMobileActual && slickInstance) {
        activeIndex = slickInstance.currentSlide;
        totalRealSlides = slickInstance.slideCount;
        const activeSlide = allSlides.eq(activeIndex);
        allSlides.removeClass('is-visible is-hover');

        if (activeSlide.length) {
          let currentVariantIdType = null;

          allSlides.each((index, slide) => {
            slide = $(slide);

            if (slide.data('media-id') == sId) currentVariantIdType = 'silver';
            else if (slide.data('media-id') == gId) currentVariantIdType = 'gold';

            if (index === activeIndex) {
              if (currentVariantIdType === 'silver') targetSelector = selectors.filter('.silver-variant');
              else if (currentVariantIdType === 'gold') targetSelector = selectors.filter('.gold-variant');

              return false;
            }
          });
        }
      } else {
        if (currentSelectedSelector.length) {
          const targetMediaId = currentSelectedSelector.data('variant-media-id');
          allSlides.removeClass('is-visible is-hover');
          imageLinks.attr('href', '#');

          allSlides.each((index, slide) => {
            slide = $(slide);

            if (slide.data('media-id') == targetMediaId) {
              slide.addClass('is-visible');
              activeIndex = index;
            }
          });
        }

        if (progressBar.length) progressBar.css('display', 'none');
      }

      if (targetSelector.length) {
        if (targetSelector[0] !== currentSelectedSelector[0] || forceInitial) {
          selectors.removeClass('selected');
          targetSelector.addClass('selected');
        }

        selectedVariantUrl = targetSelector.data('variant-url');
        selectedVariantId = targetSelector.data('variant-id');
        finalUrl = buildVariantUrl(selectedVariantUrl, selectedVariantId);

        if (title.length) title.attr('href', finalUrl);
        if (price.length) price.attr('href', finalUrl);

        if (isMobileActual) {
          imageLinks.attr('href', finalUrl);
        } else {
          allSlides.each((i, slide) => {
            slide = $(slide);
            const slideLink = slide.find('.product-image-link');

            if (slide.hasClass('is-visible') || slide.hasClass('is-hover')) {
              slideLink.attr('href', finalUrl);
            } else {
              slideLink.attr('href', '#');
            }
          });
        }
      }

      if (isMobileActual && progressBar.length && totalRealSlides > 0) {
        progressBar.css('display', 'block');
        const indicatorScale = 1 / totalRealSlides;
        const progressPosition = activeIndex * 100 * indicatorScale;
        progressBarIndicator.css('transform', `translateX(${progressPosition}%) scaleX(${indicatorScale})`);
      }
    }

    variantSelectors.on('click', function(e) {
      e.preventDefault();

      const selector = $(this);
      const targetMediaId = selector.data('variant-media-id');

      variantSelectors.removeClass('is-selected');
      selector.addClass('is-selected');

      if (checkIsMobile() && productCarousel) {
        let targetIndex = -1;

        allSlides.each((index, slide) => {
          if ($(slide).data('media-id') == targetMediaId) {
            targetIndex = index;
            return false;
          }
        });

        if (targetIndex !== -1) {
          productCarousel.slick('slickGoTo', targetIndex);
        }
      } else {
        allSlides.removeClass('is-visible is-hover');

        allSlides.each((index, slide) => {
          slide = $(slide);

          if (slide.data('media-id') == targetMediaId) {
            slide.addClass('is-visible');
          }
        });
      }

      updateUI(
        productCarousel && productCarousel.hasClass('slick-initialized') ? productCarousel.get(0).slick : null,
        totalSlides,
        progressBarIndicator,
        variantSelectors,
        imageLinks,
        titleLink,
        priceLink,
        card,
        silverMediaId,
        goldMediaId,
        true
      );
    });

    const onMouseEnter = () => {
      if (checkIsMobile()) return;

      const currentSelected = card.find('.product-variant-selector.is-selected');
      if (!currentSelected.length) return;

      const selectedMediaId = currentSelected.data('variant-media-id');
      const selectedVariantUrl = currentSelected.data('variant-url');
      const selectedVariantId = currentSelected.data('variant-id');
      const finalUrl = buildVariantUrl(selectedVariantUrl, selectedVariantId);

      let firstSlide = null;
      let secondSlide = null;
      let firstIndex = -1;

      allSlides.each((index, slide) => {
        slide = $(slide);

        if (slide.data('media-id') === selectedMediaId && firstIndex === -1) {
          firstIndex = index;
          return false;
        }
      });

      if (firstIndex !== -1) {
        let nextIndex = firstIndex + 1;

        while (nextIndex < totalSlides) {
          if (allSlides.eq(nextIndex).data('media-id') !== selectedMediaId) {
            secondSlide = allSlides.eq(nextIndex);
            break;
          }
          nextIndex++;
        }

        if (!secondSlide && totalSlides > 1) {
          for (let i = 0; i < firstIndex; i++) {
            if (allSlides.eq(i).data('media-id') !== selectedMediaId) {
              secondSlide = allSlides.eq(i);
              break;
            }
          }
        }

        firstSlide = allSlides.eq(firstIndex);
      }

      if (firstSlide && secondSlide && secondSlide.length) {
        firstSlide.removeClass('is-visible is-hover');
        secondSlide.removeClass('is-visible').addClass('is-hover');
        secondSlide.find('.product-image-link').attr('href', finalUrl);
      } else if (firstSlide && firstSlide.length) {
        firstSlide.removeClass('is-hover').addClass('is-visible');
      }
    };

    const onMouseLeave = () => {
      if (checkIsMobile()) return;

      const currentSelected = card.find('.product-variant-selector.selected');
      if (!currentSelected.length) return;

      const selectedMediaId = currentSelected.data('variant-media-id');
      const selectedVariantUrl = currentSelected.data('variant-url');
      const selectedVariantId = currentSelected.data('variant-id');
      const finalUrl = buildVariantUrl(selectedVariantUrl, selectedVariantId);

      allSlides.removeClass('is-hover is-visible');

      allSlides.each((index, slide) => {
        slide = $(slide);
        const slideLink = slide.find('.product-image-link');

        if (slide.data('media-id') === selectedMediaId) {
          slide.addClass('is-visible');
          slideLink.attr('href', finalUrl);
        } else {
          slideLink.attr('href', '#');
        }
      });
    };

    const handleHoverListeners = (isMobileActual) => {
      const carouselContainer = card.find('.product-card-carousel');

      carouselContainer.off('mouseenter', onMouseEnter);
      carouselContainer.off('mouseleave', onMouseLeave);

      if (!isMobileActual) {
        carouselContainer.on('mouseenter', onMouseEnter);
        carouselContainer.on('mouseleave', onMouseLeave);
      }
    };

    $(window).on('resize', () => {
      const newIsMobile = checkIsMobile();

      if (newIsMobile !== isMobileState) {
        isMobileState = newIsMobile;
        initCarousel();
      }

      handleHoverListeners(newIsMobile);

      if (!newIsMobile) {
        updateUI(null, totalSlides, progressBarIndicator, variantSelectors, imageLinks, titleLink, priceLink, card, silverMediaId, goldMediaId);
      }
    });

    initCarousel();
    handleHoverListeners(isMobileState);
  }

  $(document).ready(function() {
    const existingCards = $('.product-card-wrapper');

    existingCards.each((i, card) => {
      initializeCard('static-load', card);
    });

    const bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          const newNodes = $(mutation.addedNodes);

          if (newNodes.hasClass('product-card-wrapper') && !newNodes.hasClass('js-custom-card-init')) {
            initializeCard('observer-direct', newNodes);
          }

          const childrenCards = newNodes.find('.product-card-wrapper:not(.js-custom-card-init)');

          if (childrenCards.length > 0) {
            childrenCards.each((i, card) => {
              initializeCard('observer-child', card);
            });
          }
        }
      });
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    let checkCount = 0;

    const fallbackInterval = setInterval(() => {
      checkCount++;

      const missedCards = $('.product-card-wrapper:not(.js-custom-card-init)');

      if (missedCards.length > 0) {
        missedCards.each((i, card) => {
          initializeCard('fallback-interval', card);
        });
      }

      if (checkCount >= 5) clearInterval(fallbackInterval);
    }, 2000);
  });

})(jQuery);